import { useTimezone, formatInTimezone } from '@kioskgaming/ui';

export function useFormatDate() {
  const { timezone } = useTimezone();
  return (
    value: string | Date | number | null | undefined,
    options?: Intl.DateTimeFormatOptions,
  ) => formatInTimezone(value, timezone, options);
}
